import 'bootstrap-daterangepicker/daterangepicker.css';
import 'bootstrap/dist/css/bootstrap.css';
import React, { useContext, useEffect, useState, useRef } from 'react';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import '../App.css';
import {
  BusFareAddOnContext,
  BusFareDepartContext,
  BusFareReturnContext,
  LoyaltyDiscountContext,
  SelectSeatDepartContext,
  SelectSeatReturnContext,
  TotalBusFareContext,
} from '../UserContext';

import {
  tokenIsValid,
  getToken,
  calculateDateRange,
  changeDateFormatToMMDDYYYY,
  changeDateFormatToYYYYMMDD,
  // checkVenue,
  passengerValidation,
  isShuttleBus,
  sessionStorageGetItem,
  sessionStorageSetItem,
} from './Function';

import './HeaderSection.css';
import { LinkButton } from './LinkButton';
import { useSearchParams } from 'react-router-dom';
import { AutocompleteInput } from './AutocompleteInput';
import moment from 'moment';
import DatePicker from 'react-datepicker';

function Booking(props) {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  // const [availableDestination, setAvailableDestination] = useState(null);
  // console.log(availableDestination)
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions(),
    );

    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
  }
  const [searchParams, setSearchParams] = useSearchParams();
  const request_id = searchParams.get('request_id') ?? '';

  const { height, width } = useWindowDimensions();

  const [depart, setDepart] = useState({ label: '', value: '' });
  const [destination, setDestination] = useState({ label: '', value: '' });

  const [depart_date, setDepartDate] = useState(moment().format('YYYY-MM-DD'));
  let [return_date, setReturnDate] = useState('');
  const [passenger, setPassenger] = useState(1);
  const [oneWayTrip, setOneWayTrip] = useState(true);
  const [show, setShow] = useState(false);
  // console.log(oneWayTrip);
  // console.log(show);
  const subplace_data = props.subplace_data;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // useEffect(() => {
  // let selected_subplace_id = 32;
  // if (sessionStorageGetItem('Origin_data') != null) {
  // 	const origin_data = JSON.parse(sessionStorageGetItem('Origin_data'));
  // 	selected_subplace_id = origin_data.subplaceid;
  // }

  // const getAvailableDestination = async () => {
  // 	try {
  // 		const response = await fetch(
  // 			`${SERVER_URL}/me/get/subplaces/origin/${selected_subplace_id}`,
  // 			{
  // 				headers: {
  // 					Authorization: getToken(),
  // 				},
  // 			}
  // 		);
  // 		if (!response.ok) {
  // 			throw new Error(
  // 				`This is an HTTP error: The status is ${response.status}`
  // 			);
  // 		}
  // 		let actualData = await response.json();
  // 		setAvailableDestination(actualData);
  // 		setError(null);
  // 	} catch (err) {
  // 		setError(err.message);
  // 		setAvailableDestination(null);
  // 	} finally {
  // 		setLoading(false);
  // 	}
  // };
  // tokenIsValid();
  // getAvailableDestination();
  // }, [depart]);

  function handleCallback(date) {
    // console.log(date)
    // console.log(typeof(date))
    // // console.log(changeDateFormatToYYYYMMDD(start._d));
    if (date && typeof date === 'object') {
      if (date.length > 0) {
        var start = document.getElementById('calendar_depart');
        var end = document.getElementById('calendar_return');
        // console.log(end)
        var _depart = changeDateFormatToYYYYMMDD(date[0]);
        var _return = changeDateFormatToYYYYMMDD(date[1]);
        start.value = changeDateFormatToMMDDYYYY(_depart);
        end.value = changeDateFormatToMMDDYYYY(_return);
        var el = document.getElementsByClassName('calendar');
        // console.log(el)
        el[0].classList.remove('show');
        setDepartDate(_depart);
        setReturnDate(_return);
      } else {
        var start = document.getElementById('calendar_depart');
        var _depart = changeDateFormatToYYYYMMDD(date);
        start.value = changeDateFormatToMMDDYYYY(_depart);
        // var el = document.getElementsByClassName('calendar');
        // // console.log(el)
        // el[0].classList.remove('show')
        setDepartDate(_depart);
        setReturnDate('');
      }
    }
  }

  function closeCalendar(oneway) {
    if (oneway === true) {
      setReturnDate('');
    }
    setShow(false);
  }

  function handleCallbackReturn(end) {
    // console.log(end);
    setReturnDate(changeDateFormatToYYYYMMDD(end._d));
  }
  // console.log(depart_date)
  // console.log(return_date)
  const handleApply = (event, picker) => {
    picker.element.val(picker.startDate.format('DD MMM YY'));
  };

  const { selectedDepartSeat, setDepartSeat } = useContext(
    SelectSeatDepartContext,
  );
  const { selectedReturnSeat, setReturnSeat } = useContext(
    SelectSeatReturnContext,
  );
  let { TotalBusFare, setTotalBusFare } = useContext(TotalBusFareContext);
  let { BusFareAddOn, setBusFareAddOn } = useContext(BusFareAddOnContext);
  const { BusFareDepart, setBusFareDepart } = useContext(BusFareDepartContext);
  const { BusFareReturn, setBusFareReturn } = useContext(BusFareReturnContext);
  const { TotalLoyalty, setLoyalty } = useContext(LoyaltyDiscountContext);

  function pad2(n) {
    return (n < 10 ? '0' : '') + n;
  }

  const setOriginData = (selected_place) => {
    sessionStorage.removeItem('Origin_data');

    for (let i = 0; i < subplace_data.length; i++) {
      if (selected_place === subplace_data[i].placeuniqueshortname) {
        // setDepart(selected_place);

        sessionStorageSetItem(
          'Origin_data',
          JSON.stringify({
            placeid: subplace_data[i].placeid,
            placename: subplace_data[i].placename,
            placedisplayname: subplace_data[i].placedisplayname,
            placeuniqueshortname: subplace_data[i].placeuniqueshortname,

            subplaceid: null,
            subplacename: null,
            subplaceuniqueshortname: null,
            subplacedisplayname1: null,
          }),
        );
      } else {
        for (let j = 0; j < subplace_data[i].subplaces.length; j++) {
          if (
            subplace_data[i].subplaces[j].subplaceuniqueshortname ===
            selected_place
          ) {
            // setDepart(subplace_data[i].subplaces[j].subplaceuniqueshortname);
            sessionStorageSetItem(
              'Origin_data',
              JSON.stringify({
                placeid: subplace_data[i].placeid,
                placename: subplace_data[i].placename,
                placedisplayname: subplace_data[i].placedisplayname,
                placeuniqueshortname: subplace_data[i].placeuniqueshortname,

                subplaceid: subplace_data[i].subplaces[j].subplaceid,
                subplacename: subplace_data[i].subplaces[j].subplacename,
                subplaceuniqueshortname:
                  subplace_data[i].subplaces[j].subplaceuniqueshortname,
                subplacedisplayname1:
                  subplace_data[i].subplaces[j].subplacedisplayname1,
              }),
            );
          }
        }
      }
    }
  };

  const setDestinationData = (selected_place) => {
    sessionStorage.removeItem('Destination_data');
    for (let i = 0; i < subplace_data.length; i++) {
      if (selected_place === subplace_data[i].placeuniqueshortname) {
        // setDestination(selected_place);

        sessionStorageSetItem(
          'Destination_data',
          JSON.stringify({
            placeid: subplace_data[i].placeid,
            placename: subplace_data[i].placename,
            placedisplayname: subplace_data[i].placedisplayname,
            placeuniqueshortname: subplace_data[i].placeuniqueshortname,

            subplaceid: null,
            subplacename: null,
            subplaceuniqueshortname: null,
            subplacedisplayname1: null,
          }),
        );
      } else {
        for (let j = 0; j < subplace_data[i].subplaces.length; j++) {
          if (
            subplace_data[i].subplaces[j].subplaceuniqueshortname ===
            selected_place
          ) {
            // setDestination(subplace_data[i].subplaces[j].subplaceuniqueshortname);
            sessionStorageSetItem(
              'Destination_data',
              JSON.stringify({
                placeid: subplace_data[i].placeid,
                placename: subplace_data[i].placename,
                placedisplayname: subplace_data[i].placedisplayname,
                placeuniqueshortname: subplace_data[i].placeuniqueshortname,

                subplaceid: subplace_data[i].subplaces[j].subplaceid,
                subplacename: subplace_data[i].subplaces[j].subplacename,
                subplaceuniqueshortname:
                  subplace_data[i].subplaces[j].subplaceuniqueshortname,
                subplacedisplayname1:
                  subplace_data[i].subplaces[j].subplacedisplayname1,
              }),
            );
          }
        }
      }
    }
  };

  const handleSubmit = (event) => {
    var d = new Date();
    var month = pad2(d.getMonth() + 1); //months (0-11)
    var day = pad2(d.getDate()); //day (1-31)
    var year = d.getFullYear();
    var formattedDate = year + '-' + month + '-' + day;
    // console.log(depart)
    // console.log(destination)
    // console.log(depart_date)
    // console.log(return_date)
    // console.log(passenger)
    const passengerCheck = passengerValidation(passenger);
    // console.log(passengerCheck)

    if (
      depart.value === '' ||
      destination.value === '' ||
      depart_date === '' ||
      passenger === ''
    ) {
      if (depart_date && passenger) {
        if (depart.value === '' || destination.value === '') {
          event.preventDefault();
          alert('Location no found.');
        }
      } else {
        event.preventDefault(); //prevent page refresh
        alert('Please Key In all data');
      }
    } else {
      // if (checkVenue() == false) {
      // 	event.preventDefault(); //prevent page refresh
      // 	alert('Selected Origin or Destination is invalid!');
      // }

      if (return_date === '') {
        return_date = depart_date;
      }

      if (depart_date < formattedDate || return_date < depart_date) {
        event.preventDefault(); //prevent page refresh
        alert(
          'Selected date cannot be earlier than today or return date cannot be earlier than depart date',
        );
      }

      // if (calculateDateRange(depart_date, return_date) > 6) {
      //     event.preventDefault(); //prevent page refresh
      //     alert("Return date cannot be more than 7 days");
      // }

      if (passengerCheck === false) {
        event.preventDefault(); //prevent page refresh
        alert('Passenger should not less than 1 or more than 8!');
      }
    }
    // 👇️ clear all input values in the form

    setTotalBusFare(0);
    setBusFareAddOn([]);
    setBusFareDepart(0);
    setBusFareReturn(0);
    setLoyalty(0);
    setDepartSeat([]);
    setReturnSeat([]);

    sessionStorage.removeItem('departData');
    sessionStorage.removeItem('returnData');
    sessionStorage.removeItem('departDataMultiModal');

    sessionStorage.removeItem('busFare');
    sessionStorage.removeItem('loyalty');
    sessionStorage.removeItem('addOn');
    sessionStorage.removeItem('selectedDepartSeat');
    sessionStorage.removeItem('selectedReturnSeat');
    sessionStorage.removeItem('selected_addon_data');
    sessionStorage.removeItem('addOnSession');
    sessionStorage.removeItem('addon_data');
    sessionStorage.removeItem('depart_TripKey');
    sessionStorage.removeItem('return_TripKey');
    sessionStorage.removeItem('rescheduleAmount');
    sessionStorage.removeItem('history_guid');
    sessionStorage.removeItem('addOn');
    sessionStorage.removeItem('oldcartguid');
  };

  function showCalendar() {
    setShow(!show);
    // var el = document.getElementsByClassName('calendar');
    // // console.log(el)
    // el[0].classList.add('show');
  }

  function selectedOneOrTwoWay(selected) {
    setOneWayTrip(selected);
    if (selected == true) {
      var end = document.getElementById('calendar_return');
      end.value = null;
      setReturnDate('');
    }
  }

  // function clearDestination() {
  // 	// setDestinationData('');
  // 	var dv = document.getElementById('destination_venue');
  // 	dv.value = '';
  // }

  function swapVenue() {
    if (depart.value !== '' && destination.value !== '') {
      var ov = document.getElementById('origin_venue');
      var dv = document.getElementById('destination_venue');
      var tempOV = ov.value;
      var tempDV = dv.value;
      ov.value = tempDV;
      dv.value = tempOV;
      setOriginData(ov.value);
      setDestinationData(dv.value);
      setDepart(destination);
      setDestination(depart);
    }
  }

  const predefinedOrigins = [
    { label: 'Johor (All Locations)', value: 'johor' },
    { label: 'Singapore (All Locations)', value: 'singapore' },
    { label: 'Kuala Lumpur (All Locations)', value: 'kualalumpur' },
    { label: 'Malacca (All Locations)', value: 'malacca' },
    { label: 'Selangor (All Locations)', value: 'selangor' },
  ].sort((a, b) => a.label.localeCompare(b.label));
  const predefinedDestinations = [
    { label: 'Johor (All Locations)', value: 'johor' },
    { label: 'Singapore (All Locations)', value: 'singapore' },
    { label: 'Kuala Lumpur (All Locations)', value: 'kualalumpur' },
    { label: 'Malacca (All Locations)', value: 'malacca' },
    { label: 'Selangor (All Locations)', value: 'selangor' },
  ].sort((a, b) => a.label.localeCompare(b.label));

  const [origins, setOrigins] = useState(predefinedOrigins);
  const [destinations, setDestinations] = useState(predefinedDestinations);

  function filterLocations(all, allowedValues) {
    return all.filter((item) => allowedValues.includes(item.value));
  }

  function updatePredefinedLocations(value, direction) {
    const allowedCombos = {
      kualalumpur: ['johor', 'singapore'],
      malacca: [, 'singapore'],
      johor: ['johor', 'selangor', 'kualalumpur'],
      selangor: ['singapore', 'johor'],
      singapore: ['malacca', 'kualalumpur', 'selangor'],
    };

    if (!value) {
      setOrigins(predefinedOrigins);
      setDestinations(predefinedDestinations);
      return;
    }

    if (direction === 'origin') {
      const allowedDestinations = allowedCombos[value] ?? [];

      setDestinations(
        filterLocations(predefinedDestinations, allowedDestinations),
      );
    } else {
      const allowedOrigins = Object.entries(allowedCombos)
        .filter(([_, destinations]) => destinations.includes(value))
        .map(([origin]) => origin);

      setOrigins(filterLocations(predefinedOrigins, allowedOrigins));
    }
  }

  // const [showOriginSuggestions, setShowOriginSuggestions] = useState(false);
  // const originRef = useRef(null);

  // const [showDestSuggestions, setShowDestSuggestions] = useState(false);
  // const destRef = useRef(null);

  return (
    <div className='booking-container'>
      <form
        className='form'
        action=''
        method='get'
        encType='multipart/form-data'
        onSubmit={handleSubmit}
      >
        <div className='form-grid'>
          <Row>
            <Col md={12}>
              <div className='title'>
                <h1 className=''>Book Bus Ticket</h1>
              </div>
            </Col>
            <Col md={4}>
              <div className='item2 mt-4'>
                <AutocompleteInput
                  id='origin_venue'
                  name='origin_venue'
                  placeholder='Type stop name'
                  label='Origin'
                  predefinedOptions={origins}
                  apiEndpoint={`${SERVER_URL}/me/get/subplaces/search`}
                  getToken={getToken}
                  onSelect={(value, label, parent) => {
                    setDepart({ label, value });
                    setOriginData(value);
                    updatePredefinedLocations(parent, 'origin');
                    // clearDestination();
                  }}
                />
              </div>
            </Col>
            <Col md={4}>
              <div className='item2 mt-4'>
                <img
                  onClick={swapVenue}
                  className='icon-switch'
                  src='images/vector.png'
                  alt=''
                />
                <AutocompleteInput
                  id='destination_venue'
                  name='destination_venue'
                  placeholder='Type stop name'
                  label='Destination'
                  predefinedOptions={destinations}
                  apiEndpoint={`${SERVER_URL}/me/get/subplaces/search`}
                  getToken={getToken}
                  onSelect={(value, label, parent) => {
                    setDestination({ label, value });
                    setDestinationData(value);
                    updatePredefinedLocations(parent, 'destination');
                  }}
                />
              </div>
            </Col>

            <Col
              md={4}
              className='mt-4 date-wrapper'
              style={{
                display: 'flex',
              }}
            >
              <div className='trip-date-input'>
                <p>Depart Date</p>
                <DatePicker
                  minDate={new Date()}
                  selected={
                    depart_date && !isNaN(Date.parse(depart_date))
                      ? new Date(depart_date)
                      : new Date()
                  }
                  onChange={(e) =>
                    e
                      ? setDepartDate(moment(e).format('YYYY-MM-DD'))
                      : new Date()
                  }
                  dateFormat='dd/MM/yyyy'
                  id='depart-date'
                  // onKeyDown={(e) => e.preventDefault()}
                />
              </div>

              <div className='trip-date-input'>
                <p>Return Date</p>

                <DatePicker
                  minDate={depart_date ? new Date(depart_date) : new Date()}
                  selected={
                    return_date && !isNaN(Date.parse(return_date))
                      ? new Date(return_date)
                      : undefined
                  }
                  onChange={(e) => {
                    e
                      ? setReturnDate(moment(e).format('YYYY-MM-DD'))
                      : setReturnDate('null');
                  }}
                  dateFormat='dd/MM/yyyy'
                  isClearable={true}
                  placeholderText='Optional'
                  id='return-date'
                />
              </div>
            </Col>

            {/* <Col md={4}>
              <div className='item3 mt-4'>
                {show && (
                  <div className='checkOneWay'>
                    <Form.Check
                      type='radio'
                      id='one_way'
                      label='One way'
                      aria-label='oneway'
                      name='one_way'
                      checked={oneWayTrip}
                      onChange={() => selectedOneOrTwoWay(true)}
                    />
                    <Form.Check
                      className='twoway'
                      type='radio'
                      id='two_way'
                      label='Return'
                      aria-label='oneway'
                      name='one_way'
                      checked={!oneWayTrip}
                      onChange={() => selectedOneOrTwoWay(false)}
                    />
                  </div>
                )}

                <label>Depart</label>
                <img
                  className='icon-calendar'
                  src='images/calendar.png'
                  alt=''
                />

                <input
                  id='calendar_depart'
                  autoComplete='off'
                  readOnly
                  className={`${
                    oneWayTrip
                      ? 'border-none pt-22px'
                      : 'half-width border-none box-size border-right pt-22px'
                  }`}
                  type='text'
                  name='depart'
                  placeholder='DD/MM/YYYY'
                  format='DD/MM/YYYY'
                  onClick={showCalendar}
                  minDate={
                    return_date
                      ? moment(return_date).add(1, 'days').format('YYYY-MM-DD')
                      : undefined
                  }
                  value={moment(depart_date ? depart_date : undefined).format(
                    'DD/MM/YYYY'
                  )}
                />

                {!oneWayTrip && (
                  <>
                    <label>Return</label>
                    <img
                      className='icon-calendar'
                      src='images/calendar.png'
                      alt=''
                    />
                    <input
                      id='calendar_return'
                      autoComplete='off'
                      readOnly
                      className='half-width border-none box-size pt-22px'
                      type='text'
                      name='return'
                      placeholder='DD/MM/YYYY'
                      onClick={showCalendar}
                      minDate={depart_date}
                      value={
                        return_date
                          ? moment(return_date).format('DD/MM/YYYY')
                          : return_date
                      }
                    />
                  </>
                )}

                {show && (
                  <div className='calendar-container'>
                    <Calendar
                      className='calendar'
                      prev2Label={null}
                      next2Label={null}
                      minDate={new Date()}
                      showDoubleView={width > 768}
                      selectRange={!oneWayTrip}
                      onChange={handleCallback}
                      onClickDay={(value) => handleCallback(value)}
                      goToRangeStartOnSelect={false}
                    />
                    <button
                      type='button'
                      className='calendar_button'
                      onClick={() => closeCalendar(oneWayTrip)}
                    >
                      Confirm
                    </button>
                  </div>
                )}
              </div>
            </Col> */}

            {/* <input className="half-width border-none box-size pt-3" type="date" name="return" onChange={event => setReturnDate(event.target.value)} required placeholder="Return" /> */}
            <Col md={4} className='mt-4'>
              <div className='item4'>
                <label>Passenger</label>
                <input
                  className='full-width border-none box-size pt-3'
                  type='number'
                  min='1'
                  max='8'
                  name='passenger'
                  value={passenger}
                  onChange={(event) => setPassenger(event.target.value)}
                  required
                />
              </div>
            </Col>
            <Col md={8} className='mt-4'>
              <h1 className='item5'>
                <LinkButton
                  className='btns'
                  type='submit'
                  buttonStyle='btn--outline'
                  buttonSize='btn--full'
                  onClick={handleSubmit}
                  linkTo='/pickDepart'
                  params={[
                    `depart=${depart.value}`,
                    `destination=${destination.value}`,
                    `depart_date=${depart_date}`,
                    `return_date=${return_date === '' ? null : return_date}`,
                    `passenger=${passenger}`,
                    `request_id=${request_id}`,
                  ]}
                >
                  Search Bus
                </LinkButton>
              </h1>
            </Col>
          </Row>
        </div>
      </form>
    </div>
  );
}

export default Booking;
